module.exports = __webpack_public_path__ + "img/document.76a3c25f.svg";